(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
(() => {
  if (customElements.get('sca-cart-page')) return;
  class ScentalyaCartPage extends HTMLElement {
    connectedCallback() {
      if (this.scaInitialized) return;
      this.scaInitialized = true;
      this.busy = false;
      this.revision = 0;
      this.addEventListener('click', (event) => this.onClick(event), true);
      this.addEventListener('change', (event) => this.onChange(event), true);
      this.addEventListener('submit', (event) => this.onSubmit(event), true);
      this.loadRecommendations();
      this.hideEmptyRecommendations();
      this.hideDuplicatePayments();
      this.paymentObserver = new MutationObserver(() => this.hideDuplicatePayments());
      this.paymentObserver.observe(document.body, { childList: true, subtree: true });
      document.addEventListener('cart:updated', (event) => { if (event.detail?.source !== 'sca-cart-page') this.scheduleRefresh(); });
      window.addEventListener('pageshow', (event) => { if (event.persisted) this.scheduleRefresh(); });
      window.addEventListener('focus', () => this.scheduleRefresh());
    }
    disconnectedCallback() { this.paymentObserver?.disconnect(); }
    hideDuplicatePayments() {
      document.querySelectorAll('h2,h3,h4,p,div,span').forEach((heading) => {
        if (heading.closest('sca-cart-page') || heading.textContent.trim().toLowerCase() !== 'paiement sécurisé') return;
        let container = heading.parentElement;
        for (let depth = 0; container && depth < 3; depth += 1, container = container.parentElement) {
          if (container.matches('footer,main,body,.shopify-section') || container.querySelector('form,button,input')) break;
          const logos = container.querySelectorAll('img,svg');
          if (logos.length >= 2 && container.textContent.trim().length < 160) {
            container.hidden = true;
            container.style.setProperty('display', 'none', 'important');
            break;
          }
        }
      });
    }
    rootUrl() { return window.Shopify?.routes?.root || '/'; }
    state() { try { return JSON.parse(this.querySelector('[data-cart-state]').textContent); } catch { return {}; } }
    message(text, error = false) {
      const box = this.querySelector('[data-feedback]');
      if (!box) return;
      box.textContent = text;
      box.dataset.error = String(error);
      box.hidden = !text;
    }
    setBusy(value) {
      this.busy = value;
      this.setAttribute('aria-busy', String(value));
      this.querySelectorAll('button,input,select').forEach((element) => {
        if (value) { element.dataset.scaWasDisabled = String(element.disabled); element.disabled = true; }
        else { element.disabled = element.dataset.scaWasDisabled === 'true'; delete element.dataset.scaWasDisabled; }
      });
      this.querySelectorAll('[data-remove]').forEach((link) => {
        if (value) link.setAttribute('aria-disabled', 'true');
        else { link.removeAttribute('aria-disabled'); link.textContent = 'Retirer du panier'; }
      });
    }
    async jsonRequest(path, payload) {
      const options = { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
      if (payload) { options.method = 'POST'; options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(payload); }
      const response = await fetch(this.rootUrl() + path, options);
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Le panier n’a pas pu être mis à jour. Merci de réessayer.');
      return data;
    }
    focusTarget() {
      const element = document.activeElement;
      const line = element?.closest('[data-line-key]');
      if (element?.matches('[data-gift-wrap]')) return { wrap: true };
      return line ? { key: line.dataset.lineKey, delta: element.dataset.quantityDelta, input: element.matches('input') } : null;
    }
    async renderCart(cart) {
      const sectionId = this.dataset.sectionId;
      let html = cart?.sections?.[sectionId];
      if (!html) {
        const url = new URL(location.pathname, location.origin);
        url.searchParams.set('sections', sectionId);
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) throw new Error('La mise à jour de l’affichage a échoué. Rechargez le panier.');
        html = (await response.json())[sectionId];
      }
      const parsed = new DOMParser().parseFromString(html || '', 'text/html').querySelector('sca-cart-page');
      if (!parsed) throw new Error('Le panier a été modifié, mais son affichage n’a pas pu être actualisé. Rechargez la page.');
      const focus = this.focusTarget();
      const discountOpen = this.querySelector('.scb-discount')?.open;
      this.innerHTML = parsed.innerHTML;
      window.scentalyaGift?.paint(this.state());
      this.dataset.productId = parsed.dataset.productId || '';
      if (discountOpen && this.querySelector('.scb-discount')) this.querySelector('.scb-discount').open = true;
      this.hideEmptyRecommendations();
      this.loadRecommendations();
      if (focus?.wrap) this.querySelector('[data-gift-wrap]')?.focus({ preventScroll: true });
      if (focus && !focus.wrap) {
        const line = [...this.querySelectorAll('[data-line-key]')].find((node) => node.dataset.lineKey === focus.key);
        const target = focus.input ? line?.querySelector('input') : line?.querySelector(`[data-quantity-delta="${focus.delta}"]`);
        if (target) target.focus({ preventScroll: true });
      }
      const state = this.state();
      document.querySelectorAll('.cart-count').forEach((counter) => {
        if (window.scentalyaCartCounter) return;
        counter.textContent = String(state.item_count || 0);
        counter.hidden = !state.item_count;
        counter.style.display = state.item_count ? '' : 'none';
      });
      window.scentalyaCartCounter?.refresh();
    }
    async mutate(path, payload, success = '', checkCode = '') {
      if (this.busy) return;
      this.revision += 1;
      const generation = this.revision;
      const codeInput = this.querySelector('[data-discount-form] input');
      const previousCode = codeInput?.value || '';
      this.message('');
      this.setBusy(true);
      try {
        const data = await this.jsonRequest(path, { ...payload, sections: [this.dataset.sectionId], sections_url: location.pathname });
        const normalized = await this.normalizeWrapping(await this.jsonRequest('cart.js'));
        if (window.scentalyaGift) await window.scentalyaGift.sync(normalized);
        await this.renderCart();
        if (success) this.message(success);
        if (checkCode) {
          const applications = [...(data.cart_level_discount_applications || []), ...(data.items || []).flatMap((item) => (item.line_level_discount_allocations || []).map((allocation) => allocation.discount_application))];
          const directCodes = data.discount_codes || [];
          const match = directCodes.find((entry) => entry.code?.toLowerCase() === checkCode.toLowerCase());
          const applied = match?.applicable || applications.some((entry) => entry.type === 'discount_code' && entry.title?.toLowerCase() === checkCode.toLowerCase());
          const text = applied ? 'Votre code a été appliqué au panier.' : match?.applicable === false ? 'Ce code ne s’applique pas à votre panier.' : 'Code transmis. Sa validité et ses conditions seront vérifiées à l’étape de paiement.';
          const box = this.querySelector('[data-discount-message]');
          if (box) box.textContent = text;
          const newInput = this.querySelector('[data-discount-form] input');
          if (newInput) newInput.value = previousCode;
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'sca-cart-page', cart: this.state() } }));
      } catch (error) {
        this.message(error.message || 'Une erreur est survenue. Merci de réessayer.', true);
        window.scentalyaCartCounter?.refresh();
      } finally {
        this.setBusy(false);
        if (this.revision !== generation) this.scheduleRefresh();
      }
    }
    onClick(event) {
      const remove = event.target.closest('[data-remove]');
      const quantityButton = event.target.closest('[data-quantity-delta]');
      if (!remove && !quantityButton) return;
      if (remove && (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0)) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (this.busy) return;
      const line = (remove || quantityButton).closest('[data-line-key]');
      const input = line.querySelector('input');
      let quantity = 0;
      if (quantityButton) {
        const current = Number(line.dataset.lineQuantity);
        const step = Number(input.step) || 1;
        const minimum = Number(input.dataset.minimum) || 1;
        const delta = Number(quantityButton.dataset.quantityDelta);
        quantity = delta < 0 && current <= minimum ? 0 : current + delta * step;
        if (input.max && quantity > Number(input.max)) { this.message('La quantité maximale autorisée est atteinte.', true); return; }
      }
      if (remove) remove.textContent = 'Suppression…';
      this.mutate('cart/change.js', { id: line.dataset.lineKey, quantity }, quantity === 0 ? 'Article retiré du panier.' : 'Quantité mise à jour.');
    }
    onChange(event) {
      if (event.target.matches('[data-gift-wrap]')) {
        event.stopImmediatePropagation();
        if (this.busy) return;
        const checked = event.target.checked;
        const cart = this.state();
        const id = Number(this.dataset.wrapId);
        const lines = (cart.items || []).filter(item => item.variant_id === id);
        const text = JSON.parse(this.querySelector('[data-wrap-text]').textContent);
        if (checked && !(cart.items || []).some(item => item.variant_id !== id && !item.gift_card && item.properties?._sca_gift !== 'musc35_2026')) {
          event.target.checked = false;
          this.message(text.empty, true);
          return;
        }
        if (checked && !lines.length) {
          this.mutate('cart/add.js', { items: [{ id, quantity: 1, properties: { _sca_wrap: 'order', 'Papier cadeau': 'Fourni séparément — articles non emballés' } }] }, text.added);
        } else {
          const updates = Object.fromEntries(lines.map((item, index) => [item.key, checked && index === 0 ? 1 : 0]));
          this.mutate('cart/update.js', { updates }, checked ? text.added : text.removed);
        }
        return;
      }
      if (event.target.matches('[data-sca-gift-select]')) {
        event.stopImmediatePropagation();
        if (!this.busy && event.target.value) this.chooseGift(event.target.value);
        return;
      }
      if (!event.target.matches('.scb-quantity input')) return;
      event.stopImmediatePropagation();
      const input = event.target;
      const line = input.closest('[data-line-key]');
      if (this.busy) { input.value = line.dataset.lineQuantity; return; }
      const quantity = Number(input.value);
      const minimum = Number(input.dataset.minimum) || 1;
      if (!input.value.trim() || !Number.isInteger(quantity) || quantity < 0 || (quantity > 0 && quantity < minimum) || !input.checkValidity()) { input.value = line.dataset.lineQuantity; this.message('Merci de saisir une quantité autorisée.', true); return; }
      this.mutate('cart/change.js', { id: line.dataset.lineKey, quantity }, quantity === 0 ? 'Article retiré du panier.' : 'Quantité mise à jour.');
    }
    async chooseGift(id) {
      this.message('');
      this.setBusy(true);
      try {
        await window.scentalyaGift.choose(id);
        await this.renderCart();
        this.querySelector('[data-sca-gift-select]')?.focus({ preventScroll: true });
      } catch (error) {
        await this.renderCart().catch(() => {});
        this.message(error.message, true);
      } finally { this.setBusy(false); }
    }
    async normalizeWrapping(cart) {
      const id = Number(this.dataset.wrapId);
      const lines = (cart.items || []).filter(item => item.variant_id === id);
      if (!lines.length) return cart;
      const hasProducts = cart.items.some(item => item.variant_id !== id && !item.gift_card && item.properties?._sca_gift !== 'musc35_2026');
      if (hasProducts && lines.length === 1 && lines[0].quantity === 1) return cart;
      const updates = Object.fromEntries(lines.map((item, index) => [item.key, hasProducts && index === 0 ? 1 : 0]));
      return this.jsonRequest('cart/update.js', { updates });
    }
    async prepareCheckout() {
      this.setBusy(true);
      try {
        const cart = await this.normalizeWrapping(await this.jsonRequest('cart.js'));
        const ready = window.scentalyaGift ? await window.scentalyaGift.sync(cart) : cart;
        if (!ready.items?.length) { await this.renderCart(); this.setBusy(false); return; }
        window.location.assign(this.rootUrl() + 'checkout');
      } catch (error) { this.message(error.message, true); this.setBusy(false); }
    }
    onSubmit(event) {
      const form = event.target;
      if (form.matches('[data-discount-form]')) {
        event.preventDefault(); event.stopImmediatePropagation();
        if (this.busy) return;
        const code = form.querySelector('input').value.trim();
        if (!code) return;
        const cart = this.state();
        const applications = [...(cart.cart_level_discount_applications || []), ...(cart.items || []).flatMap((item) => (item.line_level_discount_allocations || []).map((entry) => entry.discount_application))];
        const codes = [...(cart.discount_codes || []).map((entry) => entry.code), ...applications.filter((entry) => entry.type === 'discount_code').map((entry) => entry.title), code].filter(Boolean);
        this.mutate('cart/update.js', { discount: [...new Set(codes)].join(',') }, '', code);
      } else if (form.matches('[data-reco-form]')) {
        event.preventDefault(); event.stopImmediatePropagation();
        if (this.busy) return;
        const id = Number(form.querySelector('[name="id"]').value);
        this.mutate('cart/add.js', { items: [{ id, quantity: 1 }] }, 'Article ajouté à votre panier.');
      } else if (form.matches('.scb-cart-form') && (this.busy || window.scentalyaGift || this.dataset.wrapId)) {
        event.preventDefault(); event.stopImmediatePropagation();
        if (!this.busy) this.prepareCheckout();
      }
    }
    scheduleRefresh() {
      this.revision += 1;
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(async () => {
        if (this.busy) return;
        const generation = this.revision;
        try {
          const url = new URL(location.pathname, location.origin);
          url.searchParams.set('sections', this.dataset.sectionId);
          const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) return;
          const sections = await response.json();
          if (!this.busy && this.revision === generation) await this.renderCart({ sections });
        } catch (error) { console.warn('Scentalya : synchronisation du panier indisponible.', error); }
      }, 100);
    }
    hideEmptyRecommendations() {
      const container = this.querySelector('[data-recommendations-container]');
      if (container && !container.querySelector('.scb-reco-card')) container.hidden = true;
    }
    async loadRecommendations() {
      if (this.dataset.recommendations !== 'true' || !this.dataset.productId) return;
      const container = this.querySelector('[data-recommendations-container]');
      if (!container || container.querySelector('.scb-reco-card')) return;
      const productId = this.dataset.productId;
      try {
        const url = new URL(this.dataset.recommendationsUrl, location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('product_id', productId);
        url.searchParams.set('limit', '8');
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) return;
        const html = await response.text();
        if (this.dataset.productId !== productId || !container.isConnected) return;
        const source = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendations-container]');
        if (source?.querySelector('.scb-reco-card')) { container.innerHTML = source.innerHTML; container.hidden = false; }
      } catch (error) { console.warn('Scentalya : recommandations indisponibles.', error); }
    }
  }
  customElements.define('sca-cart-page', ScentalyaCartPage);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
(() => {
  if (customElements.get('sca-collection-cart')) return;
  const roots = new Set();
  let busy = false;
  let lastCart;
  let revision = 0;
  let timer;
  const cartRoot = () => window.Shopify?.routes?.root || '/';

  async function request(path, payload) {
    const options = { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
    if (payload) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(payload);
    }
    const response = await fetch(cartRoot() + path, options);
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Le panier n’a pas pu être mis à jour. Merci de réessayer.');
    return data;
  }

  function paint(cart) {
    lastCart = cart;
    roots.forEach((root) => {
      root.querySelectorAll('.sca-cart-form').forEach((form) => {
        const quantity = cart.items.filter((item) => String(item.variant_id) === form.dataset.variantId).reduce((total, item) => total + item.quantity, 0);
        form.querySelector('.sca-cart-add').hidden = quantity > 0;
        form.querySelector('.sca-cart-stepper').hidden = quantity === 0;
        form.querySelector('.sca-cart-value').textContent = String(quantity);
      });
    });
    if (!window.scentalyaCartCounter) {
      document.querySelectorAll('.cart-count').forEach((counter) => {
        counter.textContent = String(cart.item_count);
        counter.hidden = cart.item_count === 0;
        counter.style.setProperty('display', cart.item_count > 0 ? 'flex' : 'none', 'important');
      });
    }
  }

  function lock(locked) {
    roots.forEach((root) => root.querySelectorAll('.sca-cart-form').forEach((form) => {
      form.setAttribute('aria-busy', String(locked));
      form.querySelectorAll('button').forEach((button) => { button.disabled = locked; });
    }));
  }

  async function refresh() {
    if (busy) return;
    const currentRevision = ++revision;
    try {
      const cart = await request('cart.js');
      if (!busy && currentRevision === revision) paint(cart);
    } catch (error) {
      console.warn('Scentalya : synchronisation des quantités indisponible.', error);
    }
  }

  function schedule() {
    revision += 1;
    clearTimeout(timer);
    timer = setTimeout(refresh, 80);
  }

  async function change(form, delta) {
    if (busy) return;
    busy = true;
    revision += 1;
    lock(true);
    const errorBox = form.closest('.product-item').querySelector('.sca-cart-error');
    errorBox.hidden = true;
    try {
      if (delta > 0) {
        await request('cart/add.js', { items: [{ id: Number(form.dataset.variantId), quantity: 1 }] });
        paint(await request('cart.js'));
      } else {
        const cart = await request('cart.js');
        const lines = cart.items.filter((item) => String(item.variant_id) === form.dataset.variantId);
        const line = lines[lines.length - 1];
        if (line) paint(await request('cart/change.js', { id: line.key, quantity: Math.max(0, line.quantity - 1) }));
        else paint(cart);
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: lastCart } }));
    } catch (error) {
      errorBox.textContent = error.message || 'Impossible de modifier le panier. Merci de réessayer.';
      errorBox.hidden = false;
      try { paint(await request('cart.js')); } catch {}
      console.error('Scentalya : modification de quantité échouée.', error);
    } finally {
      busy = false;
      lock(false);
      schedule();
    }
  }

  class ScentalyaCollectionCart extends HTMLElement {
    connectedCallback() {
      roots.add(this);
      if (!this.scaAbort) {
        this.scaAbort = new AbortController();
        this.addEventListener('submit', (event) => {
          const form = event.target.closest('.sca-cart-form');
          if (!form || !this.contains(form)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          change(form, 1);
        }, { signal: this.scaAbort.signal });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-sca-delta]');
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          change(button.closest('.sca-cart-form'), Number(button.dataset.scaDelta));
        }, { signal: this.scaAbort.signal });
      }
      if (lastCart) paint(lastCart);
      lock(busy);
      schedule();
    }
    disconnectedCallback() {
      roots.delete(this);
      this.scaAbort?.abort();
      this.scaAbort = undefined;
    }
  }

  customElements.define('sca-collection-cart', ScentalyaCollectionCart);
  ['cart:updated', 'cart:refresh', 'cart:change'].forEach((name) => document.addEventListener(name, schedule));
  window.addEventListener('pageshow', schedule);
  window.addEventListener('focus', schedule);
  window.addEventListener('online', schedule);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') schedule();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (customElements.get('sca-product-cart')) return;
  const roots = new Set();
  let busy = false;
  let lastCart;
  let revision = 0;
  let timer;
  const cartRoot = () => window.Shopify?.routes?.root || '/';

  async function request(path, payload) {
    const options = { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } };
    if (payload) {
      options.method = 'POST';
      if (payload instanceof FormData) options.body = payload;
      else {
        options.headers['Content-Type'] = 'application/json';
        options.body = JSON.stringify(payload);
      }
    }
    const response = await fetch(cartRoot() + path, options);
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Le panier n’a pas pu être mis à jour. Merci de réessayer.');
    return data;
  }

  function paint(cart) {
    lastCart = cart;
    roots.forEach((root) => {
      root.querySelectorAll('.sca-cart-form').forEach((form) => {
        const quantity = cart.items.filter((item) => String(item.variant_id) === form.dataset.variantId).reduce((total, item) => total + item.quantity, 0);
        form.querySelector('.sca-cart-add').hidden = quantity > 0;
        form.querySelector('.sca-cart-stepper').hidden = quantity === 0;
        form.querySelector('.sca-product-cart-controls').hidden = quantity === 0;
        form.querySelector('.sca-cart-value').textContent = String(quantity);
      });
    });
    if (!window.scentalyaCartCounter) {
      document.querySelectorAll('.cart-count').forEach((counter) => {
        counter.textContent = String(cart.item_count);
        counter.hidden = cart.item_count === 0;
        counter.style.setProperty('display', cart.item_count > 0 ? 'flex' : 'none', 'important');
      });
    }
  }

  function lock(locked) {
    roots.forEach((root) => root.querySelectorAll('.sca-cart-form').forEach((form) => {
      form.setAttribute('aria-busy', String(locked));
      form.querySelectorAll('button').forEach((button) => {
        button.disabled = locked || (form.dataset.available === 'false' && !button.matches('[data-sca-delta="-1"]'));
      });
      const select = form.querySelector('[name="id"]');
      if (select) select.disabled = locked;
    }));
  }

  async function refresh() {
    if (busy) return;
    const currentRevision = ++revision;
    try {
      const cart = await request('cart.js');
      if (!busy && currentRevision === revision) paint(cart);
    } catch (error) {
      console.warn('Scentalya : synchronisation des quantités indisponible.', error);
    }
  }

  function schedule() {
    revision += 1;
    clearTimeout(timer);
    timer = setTimeout(refresh, 80);
  }

  async function change(form, delta) {
    if (busy) return;
    busy = true;
    revision += 1;
    lock(true);
    const errorBox = form.querySelector('.sca-cart-error');
    errorBox.hidden = true;
    try {
      if (delta > 0) {
        if (form.dataset.available === 'false') return;
        const data = new FormData(form);
        data.set('id', form.dataset.variantId);
        data.set('quantity', '1');
        await request('cart/add.js', data);
        paint(await request('cart.js'));
      } else {
        const cart = await request('cart.js');
        const lines = cart.items.filter((item) => String(item.variant_id) === form.dataset.variantId);
        const line = lines[lines.length - 1];
        if (line) paint(await request('cart/change.js', { id: line.key, quantity: Math.max(0, line.quantity - 1) }));
        else paint(cart);
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: lastCart } }));
    } catch (error) {
      errorBox.textContent = error.message || 'Impossible de modifier le panier. Merci de réessayer.';
      errorBox.hidden = false;
      try { paint(await request('cart.js')); } catch {}
      console.error('Scentalya : modification de quantité échouée.', error);
    } finally {
      busy = false;
      lock(false);
      schedule();
    }
  }

  class ScentalyaProductCart extends HTMLElement {
    connectedCallback() {
      roots.add(this);
      if (!this.scaAbort) {
        this.scaAbort = new AbortController();
        this.addEventListener('submit', (event) => {
          const form = event.target.closest('.sca-cart-form');
          if (!form || !this.contains(form)) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          change(form, 1);
        }, { signal: this.scaAbort.signal, capture: true });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-sca-delta]');
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          change(button.closest('.sca-cart-form'), Number(button.dataset.scaDelta));
        }, { signal: this.scaAbort.signal });
      }
      if (!this.scaVariantsBound) {
        this.scaVariantsBound = true;
        this.addEventListener('change', (event) => {
          if (!event.target.matches('#variant-selector')) return;
          const form = event.target.closest('.sca-cart-form');
          const option = event.target.selectedOptions[0];
          form.dataset.variantId = option.value;
          form.dataset.available = option.dataset.available;
          form.querySelector('.sca-product-price').textContent = option.dataset.price;
          form.querySelector('.sca-cart-add').textContent = option.dataset.available === 'true' ? 'ajouter au panier' : 'en rupture';
          form.querySelector('.sca-cart-error').hidden = true;
          if (lastCart) paint(lastCart);
          lock(busy);
          schedule();
        });
        this.querySelectorAll('.thumbnail').forEach((thumbnail) => {
          thumbnail.addEventListener('click', () => {
            this.querySelectorAll('.thumbnail').forEach((image) => image.classList.remove('selected-thumbnail'));
            thumbnail.classList.add('selected-thumbnail');
            const image = this.querySelector('#main-image');
            image.src = thumbnail.dataset.src;
            image.alt = thumbnail.alt;
          });
        });
      }
      if (lastCart) paint(lastCart);
      lock(busy);
      schedule();
    }
    disconnectedCallback() {
      roots.delete(this);
      this.scaAbort?.abort();
      this.scaAbort = undefined;
    }
  }

  customElements.define('sca-product-cart', ScentalyaProductCart);
  ['cart:updated', 'cart:refresh', 'cart:change'].forEach((name) => document.addEventListener(name, schedule));
  window.addEventListener('pageshow', schedule);
  window.addEventListener('focus', schedule);
  window.addEventListener('online', schedule);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') schedule();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sca-collection-catalog"] && !Shopify.designMode) return;
  try {
    
if (!window.scaCatalogSortBound) {
  window.scaCatalogSortBound = true;
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-scap-sort]')) event.target.form.requestSubmit();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.scap-filters[open]').forEach((panel) => {
      panel.open = false;
      panel.querySelector('summary').focus();
    });
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sca-noel-gifts"] && !Shopify.designMode) return;
  try {
    
function updateNoelDates(){
 document.querySelectorAll('[data-noel-deadline]').forEach(el=>{const deadline=Date.parse(el.dataset.noelDeadline);if(Number.isFinite(deadline)&&Date.now()>=deadline)el.querySelector('[data-noel-deadline-text]').textContent=el.dataset.after;});
 document.querySelectorAll('[data-noel-promotion]').forEach(el=>{const end=Date.parse(el.dataset.end);if(Number.isFinite(end)&&Date.now()>=end)el.hidden=true;});
}
updateNoelDates();document.addEventListener('shopify:section:load',updateNoelDates);setInterval(updateNoelDates,60000);
(() => {
  if (customElements.get('sca-noel-cart')) return;
  let busy = false;
  class NoelCart extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('submit', async event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (busy) return;
        busy = true;
        const form = event.target;
        const button = form.querySelector('button[type="submit"]');
        const status = form.querySelector('.sn-cart-status');
        const text = button.textContent;
        const enabled = [...document.querySelectorAll('sca-noel-cart button:not(:disabled)')];
        enabled.forEach(item => { item.disabled = true; });
        button.textContent = this.dataset.adding;
        this.setAttribute('aria-busy', 'true');
        status.hidden = true;
        status.classList.remove('sn-error');
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await window.fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }, credentials: 'same-origin' });
          const item = await response.json();
          if (!response.ok) throw new Error(item.description || item.message || this.dataset.error);
          const cartResponse = await window.fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' });
          const cart = cartResponse.ok ? await cartResponse.json() : undefined;
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, item, source: 'sca-noel-cart' } }));
          window.scentalyaCartCounter?.refresh();
          status.textContent = this.dataset.added;
          status.hidden = false;
        } catch (error) {
          status.textContent = error.message || this.dataset.error;
          status.classList.add('sn-error');
          status.hidden = false;
          window.scentalyaCartCounter?.refresh();
        } finally {
          enabled.forEach(item => { item.disabled = false; });
          button.textContent = text;
          this.removeAttribute('aria-busy');
          busy = false;
        }
      }, { capture: true, signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('sca-noel-cart', NoelCart);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sca-product-accessoires"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sca-fondant-reviews')) {
  customElements.define('sca-fondant-reviews', class extends HTMLElement {
    connectedCallback() {
      this.disconnectObserver();
      this.details = this.closest('details');
      this.onToggle = () => {
        this.attachWidget();
        if (this.details?.open) requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      };
      this.details?.addEventListener('toggle', this.onToggle);
      this.observer = new MutationObserver(() => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (this.isConnected) this.attachWidget();
        });
      });
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.attachWidget();
    }
    attachWidget() {
      const selector = '#seal-review-widget, #vstar-reviews';
      const widgets = [...document.querySelectorAll(selector)].filter(widget => !widget.parentElement?.closest(selector));
      const own = widgets.find(widget => this.contains(widget));
      const populated = widgets.find(widget => widget.childElementCount > 0);
      const widget = own?.childElementCount > 0 ? own : populated || own || widgets[0];
      if (!widget || this.contains(widget)) return;
      const wrapper = widget.closest('.trustoo-reviews-wrapper') || widget;
      if (wrapper.contains(this)) return;
      this.appendChild(wrapper);
      if (this.details?.open) window.dispatchEvent(new Event('resize'));
    }
    disconnectObserver() {
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      if (this.onToggle) this.details?.removeEventListener('toggle', this.onToggle);
    }
    disconnectedCallback() {
      this.disconnectObserver();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sca-product-coffrets-fondants"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sca-fondant-reviews')) {
  customElements.define('sca-fondant-reviews', class extends HTMLElement {
    connectedCallback() {
      this.disconnectObserver();
      this.details = this.closest('details');
      this.onToggle = () => {
        this.attachWidget();
        if (this.details?.open) requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      };
      this.details?.addEventListener('toggle', this.onToggle);
      this.observer = new MutationObserver(() => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (this.isConnected) this.attachWidget();
        });
      });
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.attachWidget();
    }
    attachWidget() {
      const selector = '#seal-review-widget, #vstar-reviews';
      const widgets = [...document.querySelectorAll(selector)].filter(widget => !widget.parentElement?.closest(selector));
      const own = widgets.find(widget => this.contains(widget));
      const populated = widgets.find(widget => widget.childElementCount > 0);
      const widget = own?.childElementCount > 0 ? own : populated || own || widgets[0];
      if (!widget || this.contains(widget)) return;
      const wrapper = widget.closest('.trustoo-reviews-wrapper') || widget;
      if (wrapper.contains(this)) return;
      this.appendChild(wrapper);
      if (this.details?.open) window.dispatchEvent(new Event('resize'));
    }
    disconnectObserver() {
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      if (this.onToggle) this.details?.removeEventListener('toggle', this.onToggle);
    }
    disconnectedCallback() {
      this.disconnectObserver();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sca-product-diffuseurs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sca-fondant-reviews')) {
  customElements.define('sca-fondant-reviews', class extends HTMLElement {
    connectedCallback() {
      this.disconnectObserver();
      this.details = this.closest('details');
      this.onToggle = () => {
        this.attachWidget();
        if (this.details?.open) requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      };
      this.details?.addEventListener('toggle', this.onToggle);
      this.observer = new MutationObserver(() => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (this.isConnected) this.attachWidget();
        });
      });
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.attachWidget();
    }
    attachWidget() {
      const selector = '#seal-review-widget, #vstar-reviews';
      const widgets = [...document.querySelectorAll(selector)].filter(widget => !widget.parentElement?.closest(selector));
      const own = widgets.find(widget => this.contains(widget));
      const populated = widgets.find(widget => widget.childElementCount > 0);
      const widget = own?.childElementCount > 0 ? own : populated || own || widgets[0];
      if (!widget || this.contains(widget)) return;
      const wrapper = widget.closest('.trustoo-reviews-wrapper') || widget;
      if (wrapper.contains(this)) return;
      this.appendChild(wrapper);
      if (this.details?.open) window.dispatchEvent(new Event('resize'));
    }
    disconnectObserver() {
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      if (this.onToggle) this.details?.removeEventListener('toggle', this.onToggle);
    }
    disconnectedCallback() {
      this.disconnectObserver();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sca-product-encens"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sca-fondant-reviews')) {
  customElements.define('sca-fondant-reviews', class extends HTMLElement {
    connectedCallback() {
      this.disconnectObserver();
      this.details = this.closest('details');
      this.onToggle = () => {
        this.attachWidget();
        if (this.details?.open) requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      };
      this.details?.addEventListener('toggle', this.onToggle);
      this.observer = new MutationObserver(() => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (this.isConnected) this.attachWidget();
        });
      });
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.attachWidget();
    }
    attachWidget() {
      const selector = '#seal-review-widget, #vstar-reviews';
      const widgets = [...document.querySelectorAll(selector)].filter(widget => !widget.parentElement?.closest(selector));
      const own = widgets.find(widget => this.contains(widget));
      const populated = widgets.find(widget => widget.childElementCount > 0);
      const widget = own?.childElementCount > 0 ? own : populated || own || widgets[0];
      if (!widget || this.contains(widget)) return;
      const wrapper = widget.closest('.trustoo-reviews-wrapper') || widget;
      if (wrapper.contains(this)) return;
      this.appendChild(wrapper);
      if (this.details?.open) window.dispatchEvent(new Event('resize'));
    }
    disconnectObserver() {
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      if (this.onToggle) this.details?.removeEventListener('toggle', this.onToggle);
    }
    disconnectedCallback() {
      this.disconnectObserver();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sca-product-fondants-perso"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sca-fondant-reviews')) {
  customElements.define('sca-fondant-reviews', class extends HTMLElement {
    connectedCallback() {
      this.disconnectObserver();
      this.details = this.closest('details');
      this.onToggle = () => {
        this.attachWidget();
        if (this.details?.open) requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      };
      this.details?.addEventListener('toggle', this.onToggle);
      this.observer = new MutationObserver(() => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (this.isConnected) this.attachWidget();
        });
      });
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.attachWidget();
    }
    attachWidget() {
      const selector = '#seal-review-widget, #vstar-reviews';
      const widgets = [...document.querySelectorAll(selector)].filter(widget => !widget.parentElement?.closest(selector));
      const own = widgets.find(widget => this.contains(widget));
      const populated = widgets.find(widget => widget.childElementCount > 0);
      const widget = own?.childElementCount > 0 ? own : populated || own || widgets[0];
      if (!widget || this.contains(widget)) return;
      const wrapper = widget.closest('.trustoo-reviews-wrapper') || widget;
      if (wrapper.contains(this)) return;
      this.appendChild(wrapper);
      if (this.details?.open) window.dispatchEvent(new Event('resize'));
    }
    disconnectObserver() {
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      if (this.onToggle) this.details?.removeEventListener('toggle', this.onToggle);
    }
    disconnectedCallback() {
      this.disconnectObserver();
    }
  });
}
if (!customElements.get('sca-fondants-builder')) {
  customElements.define('sca-fondants-builder', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      clearInterval(this.interval);
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.root = this.closest('sca-refined-cart');
      this.cards = [...this.querySelectorAll('[data-mix-scent]')];
      this.counts = new Map(this.cards.map(card => [card.dataset.mixScent, 0]));
      this.formats = [...this.querySelectorAll('[data-mix-size]')];
      this.forms = [...this.root.querySelectorAll('[data-mix-form]')];
      this.busy = false;
      this.checking = false;
      const initial = this.formats.find(format => format.dataset.variantId === this.dataset.initialVariant) || this.formats[0];
      this.format = initial;
      this.size = Number(initial?.dataset.mixSize || 3);
      this.addEventListener('click', event => {
        const format = event.target.closest('[data-mix-size]');
        if (format) { this.selectFormat(format); return; }
        const control = event.target.closest('[data-mix-plus], [data-mix-minus], [data-mix-remove]');
        if (!control || this.busy || this.checking) return;
        const card = control.hasAttribute('data-mix-remove') ? this.cards.find(item => item.dataset.mixScent === control.dataset.mixRemove) : control.closest('[data-mix-scent]');
        if (!card) return;
        const key = card.dataset.mixScent, count = this.counts.get(key) || 0;
        if (control.hasAttribute('data-mix-plus')) {
          if (card.dataset.available !== 'true' || this.total() >= this.size) return;
          this.counts.set(key, count + 1);
        } else this.counts.set(key, Math.max(0, count - 1));
        this.message('');
        this.render();
        if (control.hasAttribute('data-mix-remove')) card.querySelector('[data-mix-plus]')?.focus({preventScroll:true});
      }, {signal});
      this.root.addEventListener('submit', event => {
        const form = event.target.closest('[data-mix-form]');
        if (!form || !this.forms.includes(form)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.change(form, 1);
      }, {signal, capture:true});
      this.root.addEventListener('click', event => {
        const button = event.target.closest('[data-mix-less]');
        if (button && this.forms.includes(button.closest('form'))) { event.preventDefault(); this.change(button.closest('form'), -1); }
      }, {signal});
      document.addEventListener('cart:updated', event => {
        if (event.detail?.cart) { this.cart = event.detail.cart; this.renderCart(); }
        else this.refreshCart();
      }, {signal});
      document.addEventListener('visibilitychange', () => { if (!document.hidden) { this.checkAvailability(); this.refreshCart(); } }, {signal});
      window.addEventListener('focus', () => { this.checkAvailability(); this.refreshCart(); }, {signal});
      this.interval = setInterval(() => { if (!document.hidden) this.checkAvailability(); }, 30000);
      this.render();
      this.checkAvailability();
      this.refreshCart();
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearInterval(this.interval);
    }
    total() { return [...this.counts.values()].reduce((sum, count) => sum + count, 0); }
    selection() { return this.cards.flatMap(card => Array(this.counts.get(card.dataset.mixScent) || 0).fill(card)); }
    properties() { return Object.fromEntries(this.selection().map((card, index) => ['Senteur ' + (index + 1), card.dataset.name])); }
    cartLines() {
      if (!this.cart || !this.format || this.total() !== this.size) return [];
      const properties = this.properties();
      return this.cart.items.filter(item => String(item.variant_id) === this.format.dataset.variantId && Object.entries(properties).every(([key,value]) => item.properties?.[key] === value) && !item.properties?.['Senteur ' + (this.size + 1)]);
    }
    showFormatImage(format) {
      const suffix = format.dataset.mixSize === '6' ? 'Six' : 'Three';
      const src = this.dataset['image' + suffix];
      const target = this.root.querySelector('.scapd-main-image');
      if (!src || !target) return;
      target.removeAttribute('srcset');
      target.src = src;
      target.alt = this.dataset['alt' + suffix] || target.alt;
      this.root.querySelectorAll('[data-scapd-image]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.scapdImage === src)));
      const stickyImage = this.root.querySelector('.scapd-sticky-product img');
      if (stickyImage) { stickyImage.removeAttribute('srcset'); stickyImage.src = src; stickyImage.alt = target.alt; }
    }
    selectFormat(format) {
      if (this.busy || this.checking || format.dataset.packAvailable !== 'true') return;
      this.showFormatImage(format);
      if (format === this.format) return;
      this.format = format; this.size = Number(format.dataset.mixSize);
      let left = this.size;
      for (const card of this.cards) {
        const key = card.dataset.mixScent, keep = Math.min(this.counts.get(key) || 0, left);
        this.counts.set(key, keep); left -= keep;
      }
      const url = new URL(location.href); url.searchParams.set('variant', format.dataset.variantId);
      history.replaceState({}, '', url);
      this.message('');
      this.render();
    }
    message(text) { this.querySelector('[data-mix-message]').textContent = text; }
    render() {
      const total = this.total();
      this.querySelector('[data-mix-counter]').textContent = total + '/' + this.size + ' fondants sélectionnés';
      this.formats.forEach(format => {
        format.setAttribute('aria-pressed', String(format === this.format));
        format.disabled = this.busy || this.checking || format.dataset.packAvailable !== 'true';
        const price = format.querySelector('strong'); if (price) price.textContent = format.dataset.priceLabel;
        const stock = format.querySelector('[data-mix-pack-stock]'); if (stock) stock.textContent = format.dataset.packAvailable === 'true' ? '' : 'Indisponible';
      });
      for (const card of this.cards) {
        const count = this.counts.get(card.dataset.mixScent) || 0;
        const available = card.dataset.available === 'true';
        card.classList.toggle('is-unavailable', !available);
        card.classList.toggle('is-selected', count > 0);
        card.querySelector('[data-mix-scent-count]').textContent = String(count);
        card.querySelector('[data-mix-plus]').disabled = this.busy || this.checking || !available || total >= this.size;
        card.querySelector('[data-mix-minus]').disabled = this.busy || this.checking || count === 0;
        card.querySelector('[data-mix-stock]').textContent = available ? '' : 'Indisponible';
      }
      const summary = this.querySelector('[data-mix-summary]');
      summary.replaceChildren();
      const selection = this.selection();
      for (let index = 0; index < this.size; index++) {
        const item = document.createElement('li'), card = selection[index];
        if (card) {
          const swatch = document.createElement('span'); swatch.className = 'scamix-swatch'; swatch.setAttribute('aria-hidden','true'); swatch.style.setProperty('--mix-color', card.style.getPropertyValue('--mix-color'));
          const name = document.createElement('span'); name.textContent = card.dataset.name;
          const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.mixRemove = card.dataset.mixScent; remove.textContent = '×'; remove.setAttribute('aria-label','Retirer ' + card.dataset.name); remove.disabled = this.busy || this.checking;
          item.append(swatch, name, remove);
        } else { item.className = 'is-empty'; item.textContent = 'Fondant ' + (index + 1); }
        summary.append(item);
      }
      if (this.format) {
        this.root.querySelectorAll('[data-scapd-price]').forEach(price => { price.textContent = this.format.dataset.priceLabel; });
        this.root.querySelectorAll('[data-scapd-compare]').forEach(compare => { compare.hidden = true; });
        this.root.querySelectorAll('[data-mix-unit]').forEach(unit => { unit.textContent = 'Coffret de ' + this.size + ' fondants'; });
        this.forms.forEach(form => { form.querySelector('[name="id"]').value = this.format.dataset.variantId; });
      }
      this.renderCart();
    }
    renderCart() {
      const count = this.cartLines().reduce((sum, line) => sum + line.quantity, 0);
      const remaining = Math.max(0, this.size - this.total());
      const ready = this.total() === this.size && this.format?.dataset.packAvailable === 'true';
      this.forms.forEach(form => {
        const note = form.querySelector('[data-mix-selection-note]');
        if (note) {
          note.hidden = remaining === 0;
          if (remaining > 0) note.textContent = (remaining === 1 ? note.dataset.one : note.dataset.many).replace('__remaining__', String(remaining)).replace('__size__', String(this.size));
        }
        form.setAttribute('aria-busy', String(this.busy));
        form.querySelector('[data-mix-add]').hidden = count > 0;
        form.querySelector('[data-mix-in-cart]').hidden = count === 0;
        form.querySelector('[data-mix-cart-count]').textContent = String(count);
        form.querySelector('[data-mix-add]').disabled = this.busy || this.checking || !ready;
        form.querySelector('[data-mix-more]').disabled = this.busy || this.checking || !ready;
        form.querySelector('[data-mix-less]').disabled = this.busy || this.checking || count === 0;
      });
    }
    async json(url, payload) {
      const options = {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:this.controller.signal};
      if (payload) { options.method='POST'; options.headers['Content-Type']='application/json'; options.body=JSON.stringify(payload); }
      const response = await fetch(url, options);
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'La disponibilité ne peut pas être vérifiée pour le moment.');
      return data;
    }
    async checkAvailability() {
      if (this.availabilityPromise) return this.availabilityPromise;
      this.checking = true; this.render();
      const run = async () => {
        let removed = false, failed = false;
        await Promise.all(this.cards.map(async card => {
          let available = false;
          if (card.dataset.url) {
            try { const data = await this.json(card.dataset.url + '.js'); available = data.available === true; }
            catch (error) { if (error.name === 'AbortError') return; failed = true; }
          }
          card.dataset.available = String(available);
          if (!available && this.counts.get(card.dataset.mixScent)) { this.counts.set(card.dataset.mixScent, 0); removed = true; }
        }));
        try {
          const data = await this.json(this.dataset.productUrl + '.js');
          this.formats.forEach(format => {
            const variant = data.variants.find(item => String(item.id) === format.dataset.variantId);
            format.dataset.packAvailable = String(variant?.available === true);
            if (variant) {
              format.dataset.price = String(variant.price);
              format.dataset.priceLabel = new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {style:'currency',currency:this.dataset.currency || 'EUR'}).format(variant.price / 100);
            }
          });
        } catch (error) {
          if (error.name !== 'AbortError') { failed = true; this.formats.forEach(format => { format.dataset.packAvailable='false'; }); }
        }
        if (removed) this.message('Une senteur sélectionnée est devenue indisponible. Choisissez une autre senteur.');
        else if (failed) this.message('Certaines disponibilités ne peuvent pas être vérifiées. Réessayez dans quelques instants.');
      };
      this.availabilityPromise = run().finally(() => {
        this.availabilityPromise = null; this.checking = false;
        if (this.isConnected) this.render();
      });
      return this.availabilityPromise;
    }
    cartRoot() { return window.Shopify?.routes?.root || '/'; }
    async refreshCart() {
      if (this.busy) return;
      try { this.cart = await this.json(this.cartRoot() + 'cart.js'); this.renderCart(); } catch {}
    }
    async change(form, delta) {
      if (this.busy || this.checking) return;
      const errorBox = form.querySelector('[data-mix-error]'); errorBox.hidden=true;
      this.busy=true; this.render();
      try {
        if (delta > 0) {
          await this.checkAvailability();
          if (this.total() !== this.size) throw new Error('Sélectionnez exactement ' + this.size + ' fondants avant l’ajout au panier.');
          if (this.format?.dataset.packAvailable !== 'true') throw new Error('Ce format est momentanément indisponible.');
          await this.json(this.cartRoot() + 'cart/add.js', {items:[{id:Number(this.format.dataset.variantId),quantity:1,properties:this.properties()}]});
        } else {
          this.cart = await this.json(this.cartRoot() + 'cart.js');
          const lines = this.cartLines(), line = lines[lines.length-1];
          if (line) await this.json(this.cartRoot() + 'cart/change.js', {id:line.key,quantity:Math.max(0,line.quantity-1)});
        }
        this.cart = await this.json(this.cartRoot() + 'cart.js');
        if (!window.scentalyaCartCounter) document.querySelectorAll('.cart-count').forEach(counter => { counter.textContent=String(this.cart.item_count); counter.hidden=this.cart.item_count===0; counter.style.setProperty('display',this.cart.item_count ? 'flex' : 'none','important'); });
        document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:this.cart}}));
      } catch (error) {
        if (error.name !== 'AbortError') { errorBox.textContent=error.message || 'Impossible de modifier le panier.'; errorBox.hidden=false; }
      } finally { this.busy=false; if (this.isConnected) this.render(); }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sca-product-fondants"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sca-fondant-reviews')) {
  customElements.define('sca-fondant-reviews', class extends HTMLElement {
    connectedCallback() {
      this.disconnectObserver();
      this.details = this.closest('details');
      this.onToggle = () => {
        this.attachWidget();
        if (this.details?.open) requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      };
      this.details?.addEventListener('toggle', this.onToggle);
      this.observer = new MutationObserver(() => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (this.isConnected) this.attachWidget();
        });
      });
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.attachWidget();
    }
    attachWidget() {
      const selector = '#seal-review-widget, #vstar-reviews';
      const widgets = [...document.querySelectorAll(selector)].filter(widget => !widget.parentElement?.closest(selector));
      const own = widgets.find(widget => this.contains(widget));
      const populated = widgets.find(widget => widget.childElementCount > 0);
      const widget = own?.childElementCount > 0 ? own : populated || own || widgets[0];
      if (!widget || this.contains(widget)) return;
      const wrapper = widget.closest('.trustoo-reviews-wrapper') || widget;
      if (wrapper.contains(this)) return;
      this.appendChild(wrapper);
      if (this.details?.open) window.dispatchEvent(new Event('resize'));
    }
    disconnectObserver() {
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      if (this.onToggle) this.details?.removeEventListener('toggle', this.onToggle);
    }
    disconnectedCallback() {
      this.disconnectObserver();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sca-product-huiles"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
 const link = event.target.closest('[data-scaoil-precautions]');
 if (!link) return;
 const target = document.getElementById(link.getAttribute('href').slice(1));
 if (target) { event.preventDefault(); target.open = true; target.scrollIntoView({behavior:'smooth',block:'center'}); target.querySelector('summary')?.focus({preventScroll:true}); }
});
if (!customElements.get('sca-fondant-reviews')) {
  customElements.define('sca-fondant-reviews', class extends HTMLElement {
    connectedCallback() {
      this.disconnectObserver();
      this.details = this.closest('details');
      this.onToggle = () => {
        this.attachWidget();
        if (this.details?.open) requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      };
      this.details?.addEventListener('toggle', this.onToggle);
      this.observer = new MutationObserver(() => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (this.isConnected) this.attachWidget();
        });
      });
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.attachWidget();
    }
    attachWidget() {
      const selector = '#seal-review-widget, #vstar-reviews';
      const widgets = [...document.querySelectorAll(selector)].filter(widget => !widget.parentElement?.closest(selector));
      const own = widgets.find(widget => this.contains(widget));
      const populated = widgets.find(widget => widget.childElementCount > 0);
      const widget = own?.childElementCount > 0 ? own : populated || own || widgets[0];
      if (!widget || this.contains(widget)) return;
      const wrapper = widget.closest('.trustoo-reviews-wrapper') || widget;
      if (wrapper.contains(this)) return;
      this.appendChild(wrapper);
      if (this.details?.open) window.dispatchEvent(new Event('resize'));
    }
    disconnectObserver() {
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      if (this.onToggle) this.details?.removeEventListener('toggle', this.onToggle);
    }
    disconnectedCallback() {
      this.disconnectObserver();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sca-product-pochettes"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sca-fondant-reviews')) {
  customElements.define('sca-fondant-reviews', class extends HTMLElement {
    connectedCallback() {
      this.disconnectObserver();
      this.details = this.closest('details');
      this.onToggle = () => {
        this.attachWidget();
        if (this.details?.open) requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
      };
      this.details?.addEventListener('toggle', this.onToggle);
      this.observer = new MutationObserver(() => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (this.isConnected) this.attachWidget();
        });
      });
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.attachWidget();
    }
    attachWidget() {
      const selector = '#seal-review-widget, #vstar-reviews';
      const widgets = [...document.querySelectorAll(selector)].filter(widget => !widget.parentElement?.closest(selector));
      const own = widgets.find(widget => this.contains(widget));
      const populated = widgets.find(widget => widget.childElementCount > 0);
      const widget = own?.childElementCount > 0 ? own : populated || own || widgets[0];
      if (!widget || this.contains(widget)) return;
      const wrapper = widget.closest('.trustoo-reviews-wrapper') || widget;
      if (wrapper.contains(this)) return;
      this.appendChild(wrapper);
      if (this.details?.open) window.dispatchEvent(new Event('resize'));
    }
    disconnectObserver() {
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      if (this.onToggle) this.details?.removeEventListener('toggle', this.onToggle);
    }
    disconnectedCallback() {
      this.disconnectObserver();
    }
  });
}

if (!customElements.get('sca-pouch-colors')) {
 customElements.define('sca-pouch-colors', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();
   this.controller = new AbortController();
   const signal = this.controller.signal;
   this.root = this.querySelector('sca-refined-cart');
   this.select = this.querySelector('[data-scapd-primary-buy] select[data-scapd-variant]');
   this.buttons = [...this.querySelectorAll('[data-pouch-variant]')];
   this.thumbnails = [...this.querySelectorAll('[data-pouch-color]')];
   if (!this.root || !this.buttons.length) return;
   this.addEventListener('click', event => {
    const swatch = event.target.closest('[data-pouch-variant]');
    if (swatch && this.contains(swatch)) {
     if (this.select) { this.select.value = swatch.dataset.pouchVariant; this.select.dispatchEvent(new Event('change',{bubbles:true})); }
     else this.show(swatch);
     return;
    }
    const thumb = event.target.closest('[data-pouch-color]');
    if (thumb && !thumb.hidden) this.info(thumb);
   },{signal});
   this.addEventListener('change', event => {
    if (event.target === this.select) this.show(this.buttons.find(button => button.dataset.pouchVariant === this.select.value));
   },{signal});
   this.show(this.buttons.find(button => button.dataset.pouchVariant === this.select?.value) || this.buttons.find(button => button.getAttribute('aria-pressed') === 'true') || this.buttons[0]);
   this.classList.add('is-ready');
  }
  disconnectedCallback() { this.controller?.abort(); }
  show(button) {
   if (!button) return;
   this.current = button;
   const id = button.dataset.pouchVariant;
   this.buttons.forEach(item => item.setAttribute('aria-pressed',String(item === button)));
   this.querySelector('[data-pouch-color-label]').textContent = button.dataset.pouchTitle;
   this.thumbnails.forEach(thumb => { thumb.hidden = Boolean(thumb.dataset.pouchColor && thumb.dataset.pouchColor !== id); });
   const first = this.thumbnails.find(thumb => !thumb.hidden && thumb.dataset.pouchColor === id) || this.thumbnails.find(thumb => !thumb.hidden);
   const src = first?.dataset.scapdImage || button.dataset.pouchImage;
   const alt = first?.dataset.scapdAlt || button.dataset.pouchAlt;
   const image = this.querySelector('.scapd-main-image');
   if (image && src) { image.removeAttribute('srcset'); image.src = src; image.alt = alt || button.dataset.pouchTitle; }
   this.thumbnails.forEach(thumb => thumb.setAttribute('aria-pressed',String(thumb === first)));
   const sticky = this.querySelector('.scapd-sticky-product img');
   if (sticky && src) { sticky.removeAttribute('srcset'); sticky.src = src; sticky.alt = alt || button.dataset.pouchTitle; }
   this.info(first);
  }
  info(thumb) {
   const info = this.querySelector('[data-pouch-gallery-info]');
   if (!info || !this.current) return;
   const visible = this.thumbnails.filter(item => !item.hidden);
   const index = Math.max(0,visible.indexOf(thumb)) + 1;
   info.textContent = this.current.dataset.pouchTitle + (visible.length ? ' · Photo ' + index + '/' + visible.length : '');
  }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scentalya-accueil-video"] && !Shopify.designMode) return;
  try {
    

(()=>{const init=root=>{if(root.dataset.ready)return;root.dataset.ready='true';const reduced=window.matchMedia('(prefers-reduced-motion: reduce)'),small=window.matchMedia('(max-width: 700px)'),videos=[...root.querySelectorAll('.scah-video')],control=root.querySelector('[data-video-control]');let selected=null,manualPause=false,outside=false;const choose=()=>{const mobile=root.querySelector('.scah-video-mobile'),desktop=root.querySelector('.scah-video-desktop');return small.matches?(mobile||desktop):desktop};const updateLabel=()=>{if(!control)return;control.hidden=!selected;const playing=selected&&!selected.paused;
control.textContent=playing?'⏸':'▶';
control.setAttribute('aria-label',playing?'Mettre la vidéo en pause':'Lire la vidéo');
control.title=playing?'Mettre en pause':'Lire';control.setAttribute('aria-pressed',String(!!selected&&!selected.paused))};const sync=()=>{selected=choose();videos.forEach(v=>{const active=v===selected;v.style.display=active?'block':'none';if(!active)v.pause()});if(selected){selected.muted=true;selected.playsInline=true;if(!manualPause&&!reduced.matches&&!document.hidden&&!outside){selected.play().catch(()=>{selected?.classList.remove('is-playing');updateLabel()})}else selected.pause()}updateLabel()};videos.forEach(v=>{v.addEventListener('playing',()=>{v.classList.add('is-playing');updateLabel()});v.addEventListener('pause',updateLabel);v.addEventListener('error',()=>{v.classList.remove('is-playing');updateLabel()})});if(control)control.addEventListener('click',()=>{if(!selected)return;if(selected.paused){manualPause=false;selected.play().catch(()=>{});}else{manualPause=true;selected.pause()}updateLabel()});small.addEventListener('change',sync);reduced.addEventListener('change',sync);document.addEventListener('visibilitychange',sync);if('IntersectionObserver'in window){const watch=new IntersectionObserver(es=>{outside=!es[0].isIntersecting;sync()},{threshold:.08});watch.observe(root.querySelector('.scah-hero'));const reveals=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.remove('is-pending');reveals.unobserve(e.target)}}),{threshold:.05});if(!reduced.matches)root.querySelectorAll('.scah-reveal').forEach(e=>{e.classList.add('is-pending');reveals.observe(e)})}sync();const activate=id=>{root.querySelectorAll('[data-use-button]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.useButton===id)));root.querySelectorAll('[data-use-panel]').forEach(p=>p.hidden=p.dataset.usePanel!==id);root.querySelectorAll('[data-use-photo]').forEach(p=>p.hidden=p.dataset.usePhoto!==id)};root.querySelectorAll('[data-use-button]').forEach(b=>b.addEventListener('click',()=>activate(b.dataset.useButton)));root.addEventListener('sca:select-block',e=>{const node=root.querySelector('[data-use-panel][data-block-id="'+e.detail+'"]');if(node)activate(node.dataset.usePanel)});document.addEventListener('shopify:block:select',e=>{const panel=e.target.closest('[data-use-panel]');if(panel&&root.contains(panel))activate(panel.dataset.usePanel)})};document.querySelectorAll('[data-sca-home]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-sca-home]').forEach(init));})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scentalya-carrousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scentalya-marquee')) {
    customElements.define('scentalya-marquee', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = {signal: this.controller.signal};
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.rows = [...this.querySelectorAll('.sm-row')].map(el => ({el, track: el.querySelector('.sm-track'), group: el.querySelector('.sm-group'), phase: 0, width: 0}));
        if (this.dataset.shuffle === 'true') {
          this.rows.forEach(row => {
            const cards = [...row.group.children];
            for (let i = cards.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [cards[i], cards[j]] = [cards[j], cards[i]];
            }
            row.group.append(...cards);
          });
        }
        this.hovered = false;
        this.focused = false;
        this.rate = 1;
        this.visible = true;
        this.addEventListener('pointerenter', e => {if (e.pointerType === 'mouse') this.hovered = true;}, options);
        this.addEventListener('pointerleave', () => {this.hovered = false;}, options);
        this.addEventListener('focusin', e => {if (e.target.closest('.sm-row') && e.target.matches(':focus-visible') && !e.target.closest('.sm-copy')) {this.focused = true; this.refresh();}}, options);
        this.addEventListener('focusout', () => queueMicrotask(() => {
          this.focused = !!this.querySelector('.sm-row :focus-visible'); this.refresh();
        }), options);
        this.reduced.addEventListener('change', () => {
          this.refresh();
        }, options);
        this.resize = new ResizeObserver(() => this.measure());
        this.rows.forEach(row => {this.resize.observe(row.el); this.resize.observe(row.group);});
        this.intersection = new IntersectionObserver(entries => {this.visible = entries[0].isIntersecting;});
        this.intersection.observe(this);
        this.measure();
        this.refresh();
        const tick = now => {
          const dt = Math.min((now - (this.last || now)) / 1000, 0.05);
          this.last = now;
          this.rate += ((this.hovered ? 0.3 : 1) - this.rate) * Math.min(1, dt * 6);
          if (this.running && this.visible && !document.hidden) {
            this.rows.forEach(row => {
              if (!row.width) return;
              row.phase = (row.phase + dt * Number(this.dataset.speed) * this.rate) % row.width;
              const x = row.el.dataset.direction === '-1' ? -row.phase : row.phase - row.width;
              row.track.style.transform = `translate3d(${x}px,0,0)`;
            });
          }
          this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }
      measure() {
        this.rows.forEach(row => {
          row.track.querySelectorAll('.sm-copy').forEach(copy => copy.remove());
          row.width = row.group.getBoundingClientRect().width;
          if (!row.width) return;
          row.phase %= row.width;
          const count = Math.ceil(row.el.clientWidth / row.width) + 1;
          for (let i = 0; i < count; i++) {
            const copy = row.group.cloneNode(true);
            copy.classList.add('sm-copy');
            copy.setAttribute('aria-hidden', 'true');
            copy.querySelectorAll('a').forEach(link => {link.tabIndex = -1; link.removeAttribute('data-shopify-editor-block');});
            row.track.append(copy);
          }
        });
      }
      refresh() {
        this.running = !this.focused && !this.reduced.matches;
        this.classList.toggle('sm-running', this.running);
        this.rows.forEach(row => {
          if (!this.running) {row.track.style.transform = ''; row.phase = 0;}
          else row.el.scrollLeft = 0;
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.resize?.disconnect();
        this.intersection?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scentalya-collections-onglets"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scentalya-collection-tabs')) {
    customElements.define('scentalya-collection-tabs', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = {signal:this.controller.signal};
        this.tabs = [...this.querySelectorAll('.sct-tab')];
        this.panels = [...this.querySelectorAll('.sct-panel')];
        if (!this.tabs.length) return;
        this.querySelector('.sct-tabs').setAttribute('role','tablist');
        this.tabs.forEach((tab,index) => {
          tab.setAttribute('role','tab');
          tab.setAttribute('aria-controls',tab.dataset.panel);
          const panel = this.panels.find(item => item.id === tab.dataset.panel);
          panel.setAttribute('role','tabpanel');
          panel.setAttribute('aria-labelledby',tab.id);
          tab.addEventListener('click',() => this.select(index),options);
          tab.addEventListener('keydown',event => {
            let target = index;
            if (event.key === 'ArrowRight') target = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') target = (index - 1 + this.tabs.length) % this.tabs.length;
            else if (event.key === 'Home') target = 0;
            else if (event.key === 'End') target = this.tabs.length - 1;
            else return;
            event.preventDefault();
            this.select(target);
            this.tabs[target].focus({preventScroll:true});
            this.tabs[target].scrollIntoView({block:'nearest',inline:'nearest'});
          },options);
        });
        this.select(0);
        this.classList.add('sct-ready');
        document.addEventListener('shopify:block:select',event => {
          const panel = this.panels.find(item => item.dataset.blockId === event.detail.blockId);
          if (panel) this.select(this.tabs.findIndex(tab => tab.dataset.panel === panel.id));
        },options);
      }
      select(index) {
        if (index < 0 || index >= this.tabs.length) return;
        this.tabs.forEach((tab,i) => {
          const active = i === index;
          tab.setAttribute('aria-selected',String(active));
          tab.tabIndex = active ? 0 : -1;
          const panel = this.panels.find(item => item.id === tab.dataset.panel);
          panel.hidden = !active;
        });
      }
      disconnectedCallback() {this.controller?.abort();}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scentalya-creer-projet"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('scentalya-project')) {
  customElements.define('scentalya-project', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const radios = Array.from(this.querySelectorAll('[data-kind]'));
      const groups = Array.from(this.querySelectorAll('[data-for]'));
      const update = () => {
        const selected = radios.find(radio => radio.checked)?.dataset.kind;
        groups.forEach(group => {
          const active = group.dataset.for === selected;
          group.hidden = !active;
          group.disabled = !active;
        });
      };
      radios.forEach(radio => radio.addEventListener('change', update));
      const requested = new URLSearchParams(location.search).get('type');
      if (!radios.some(radio => radio.checked) && ['pro', 'private'].includes(requested)) {
        radios.find(radio => radio.dataset.kind === requested).checked = true;
      }
      update();
      const result = this.querySelector('.spg__success, .spg__errors');
      if (result) result.focus();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
